<template>
  <SectionAccordion02
    v-if="contextData"
    :title="contextData.title"
    :description-html="contextData.description"
    :items="contextItems"
  />
</template>

<script setup lang="ts">
  import type { ISuiteProps } from '@/components/Shared/Suite/type.ts';

  interface IItem {
    name: string;
    description?: string;
  }

  interface IFaqData {
    title: string;
    description?: string;
    items: IItem[];
  }

  interface IFaq {
    component: 'faq';
    meta: {
      navigable?: string;
    };
    data: IFaqData;
  }

  type IProps = ISuiteProps<IFaq>;

  const props = defineProps<IProps>();

  const contextData = computed((): IFaqData => props.suiteData.data);

  const contextItems = computed((): IItem[] => contextData.value.items);

  export type { IFaq, IFaqData, IItem };
</script>
